import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"graphviz"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15.0001 9.99992L9.00008 9.99992L9.00008 13.9999L15.0001 13.9999V9.99992Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 5C21 6.10457 20.1046 7 19 7C17.8954 7 17.0001 6.10449 17.0001 4.99992C17.0001 3.89535 17.8954 3 19 3C20.1046 3 21 3.89543 21 5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17.0001 20.1044 17.0001 18.9998C17.0001 17.8953 17.8954 17 19 17C20.1046 17 21 17.8954 21 19Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7.00008 4.99992C7.00008 6.10449 6.10457 7 5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3C6.10457 3 7.00008 3.89535 7.00008 4.99992Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7.00008 18.9998C7.00008 20.1044 6.10457 21 5 21C3.89543 21 3 20.1046 3 19C3 17.8954 3.89543 17 5 17C6.10457 17 7.00008 17.8953 7.00008 18.9998Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0001 13.9999L9.00008 13.9999L9.00008 9.99992L12.0001 9.99984M12.0001 13.9999H15.0001V9.99992L12.0001 9.99984M12.0001 13.9999V18.9998M12.0001 9.99984V4.99984M12.0001 4.99984L17.0001 4.99992M12.0001 4.99984L7.00008 4.99992M17.0001 4.99992C17.0001 6.10449 17.8954 7 19 7C20.1046 7 21 6.10457 21 5C21 3.89543 20.1046 3 19 3C17.8954 3 17.0001 3.89535 17.0001 4.99992ZM7.00008 4.99992C7.00008 6.10449 6.10457 7 5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3C6.10457 3 7.00008 3.89535 7.00008 4.99992ZM12.0001 18.9998L7.00008 18.9998M12.0001 18.9998L17.0001 18.9998M7.00008 18.9998C7.00008 20.1044 6.10457 21 5 21C3.89543 21 3 20.1046 3 19C3 17.8954 3.89543 17 5 17C6.10457 17 7.00008 17.8953 7.00008 18.9998ZM17.0001 18.9998C17.0001 20.1044 17.8954 21 19 21C20.1046 21 21 20.1046 21 19C21 17.8954 20.1046 17 19 17C17.8954 17 17.0001 17.8953 17.0001 18.9998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Graphviz = Vue.extend<IconProps>({
  name: 'GraphvizIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'graphviz',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Graphviz;
